/**
 * Note: Previously it was possible to have more than one subscription. Now
 * only one should ever exist, so we can return it directly.
 */
export function getCurrentSubscription<T>(subscriptions?: T[]): T | undefined {
  return subscriptions?.[0];
}
